class Scrollspy {
  constructor(onSectionsUpdate) {
    this.onSectionsUpdate = onSectionsUpdate;
    this.sections = [];
    this.observer = null;
    this.handleResize = null;
    this.handleScroll = null;
    this.hideTriggerRatio = 0.5;
    this.init();
  }

  getHoverLabelWidth(label) {
    const probe = document.createElement("span");
    probe.classList.add("scrollspy-width-probe");
    probe.textContent = label;

    document.body.appendChild(probe);
    const width = Math.ceil(probe.getBoundingClientRect().width);
    probe.remove();

    return Math.max(48, width);
  }

  updateHoverWidths() {
    document.querySelectorAll(".scrollspy-list a").forEach((anchor) => {
      const label = anchor.dataset.hover?.trim();
      if (!label) return;
      anchor.style.setProperty("--scrollspy-hover-width", `${this.getHoverLabelWidth(label)}px`);
    });
  }

  updateScrollspyVisibility(scrollspyList) {
    const footerTop = document.querySelector(".iz-footer__inner");

    if (!footerTop) {
      scrollspyList.classList.remove("is-hidden-past-footer");
      return;
    }

    const hideTriggerY = window.innerHeight * this.hideTriggerRatio;
    const footerTopY = footerTop.getBoundingClientRect().top;
    scrollspyList.classList.toggle("is-hidden-past-footer", footerTopY <= hideTriggerY);
  }

  init() {
    if (!document.querySelector(".startpage")) return;

    const scrollSpyTitles = document.querySelectorAll(".scrollspy-title");
    const scrollspyList = document.querySelector(".scrollspy-list");

    if (!scrollspyList) return;

    scrollspyList.innerHTML = "";

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.querySelectorAll(".scrollspy-list li a").forEach((el) => {
            el.classList.remove("active");
          });
          const activeLink = document.querySelector(`.scrollspy-list .${entry.target.id}`);
          if (activeLink) {
            activeLink.classList.add("active");
          }
        }
      });
    }, {
      threshold: 0.5
    });

    scrollSpyTitles.forEach((item, i) => {
      const wrapper = item.closest(".scrollspy-container-wrapper");
      if (!wrapper) return;

      const li = document.createElement("li");
      const a = document.createElement("a");

      const sectionId = `section-${i + 1}`;
      wrapper.id = sectionId;
      const hoverLabel = item.textContent?.trim() || `Section ${i + 1}`;

      a.href = `#${sectionId}`;
      a.setAttribute("aria-label", hoverLabel);
      a.classList.add(sectionId);
      a.dataset.hover = hoverLabel;

      li.appendChild(a);
      scrollspyList.appendChild(li);
      this.observer.observe(wrapper);
    });

    this.updateHoverWidths();
    this.updateScrollspyVisibility(scrollspyList);

    if (this.handleResize) {
      window.removeEventListener("resize", this.handleResize);
    }
    this.handleResize = () => {
      this.updateHoverWidths();
      this.updateScrollspyVisibility(scrollspyList);
    };
    window.addEventListener("resize", this.handleResize);

    if (this.handleScroll) {
      window.removeEventListener("scroll", this.handleScroll);
    }
    this.handleScroll = () => this.updateScrollspyVisibility(scrollspyList);
    window.addEventListener("scroll", this.handleScroll, { passive: true });

    document.querySelectorAll(".scrollspy-list a").forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = anchor.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);

        if (!targetSection) return;

        const isSectionTwo = targetId === "section-2";
        targetSection.scrollIntoView({
          behavior: "smooth",
          block: isSectionTwo ? "center" : "start"
        });
      });
    });
  }
}

export default Scrollspy;




